<template>
  <span hidden />
</template>

<script lang="ts" setup>
import { useMagicKeys } from '@vueuse/core';
import { ref, watch, watchEffect } from 'vue';

const hideChrome = ref(false);

const keys = useMagicKeys();
const toggleHide = keys['Ctrl+Shift+H'];

watch(toggleHide, (pressed) => {
  if (pressed) hideChrome.value = !hideChrome.value;
});

watchEffect(() => {
  document.documentElement.classList.toggle(
    'hide-dev-chrome',
    hideChrome.value
  );
});
</script>

<style lang="scss">
.hide-dev-chrome {
  .tsqd-parent-container,
  #__vue-devtools-container__,
  #vue-inspector-container,
  .fixed.bottom-1.right-16.max-w-sm {
    display: none !important;
  }
}
</style>
